import { Flex, Skeleton } from "antd";

export default function TechServiceCardLoading() {
  return (
    <div className="bg-white rounded-xl shadow overflow-hidden relative z-20 lg:-mt-64">
      {/* Hero Banner Skeleton */}
      <Skeleton.Image active className="!h-56 !w-full rounded-t-xl" />

      {/* Content Section Skeleton */}
      <div className="p-4 space-y-4 bg-theme-slate-25">
        {/* Price and Actions Skeleton */}
        <Flex align="center" justify="space-between">
          <Skeleton.Input active className="!h-8 !w-24" />
          <Flex align="center" gap={16}>
            <Skeleton.Avatar active size="small" shape="square" />
            <Skeleton.Avatar active size="small" shape="square" />
          </Flex>
        </Flex>

        {/* Description Skeleton */}
        <Skeleton.Input active className="!h-6 !w-full" />

        {/* Bullet Points Skeleton */}
        <div className="space-y-2">
          <Skeleton
            active
            paragraph={{ rows: 3, width: ["90%", "85%", "88%"] }}
            title={false}
          />
        </div>

        {/* Tags Skeleton */}
        <Flex wrap gap={12} className="mb-6">
          <Skeleton.Button
            active
            size="small"
            className="!h-7 !w-12 !rounded"
          />
          <Skeleton.Button
            active
            size="small"
            className="!h-7 !w-16 !rounded"
          />
          <Skeleton.Button
            active
            size="small"
            className="!h-7 !w-14 !rounded"
          />
        </Flex>

        {/* CTA Button Skeleton */}
        <Skeleton.Button active block size="large" className="!rounded-full" />
      </div>
    </div>
  );
}
